export const colors = {
    white: '#FFFFFF',
    borderGray: '#DCDCDC',
    label:'#000000',
  
  };